(function($) {
 

// $(document).ready(function () {
//   $(".read-more-less").click(function () {
//     $(".collection-description").toggleClass("collection-description-expanded");
    
//     if ($(".collection-description").hasClass("collection-description-expanded")) {
//       $(this).text("Read Less");
//     } else {
//       $(this).text("Read More");
//     }
//   });
// });



 $(document).ready(function($) {
        $('.faq-item__title').on('click', function() {
            $(this).toggleClass('faq-item__title-active');
            $(this).next('.faq-item__content').slideToggle('slow');
        });
    });

  console.log('Hello from my-script.js!');

 // jQuery(document).ready(function($) {
 //    $('.toggle-description').click(function() {
 //      var $desc = $(this).prev('.product-description');
 //      if ($desc.hasClass('expanded')) {
 //        $desc.removeClass('expanded').css('max-height', '100px');
 //        $(this).text('Show More');
 //      } else {
 //        $desc.addClass('expanded').css('max-height', 'none');
 //        $(this).text('Show Less');
 //      }
 //    });
 //  });




})(jQuery);
